import { Vector3 as ThreeVector3 } from '@seddi/three';
import { degreeToRadian } from '@/core/units';
export function create() {
    return {
        distance: 0,
        origin: { x: 0, y: 0, z: 0 },
        target: { x: 0, y: 0, z: 0 },
    };
}
export function clone(other) {
    return {
        distance: other.distance,
        origin: Object.assign({}, other.origin),
        target: Object.assign({}, other.target),
    };
}
export function copy(self, other) {
    self.distance = other.distance;
    self.origin.x = other.origin.x;
    self.origin.y = other.origin.y;
    self.origin.z = other.origin.z;
    self.target.x = other.target.x;
    self.target.y = other.target.y;
    self.target.z = other.target.z;
}
export const setFromBounds = (() => {
    const RADIUS_SCALE = 1.2;
    const Z = new ThreeVector3(0, 0, 1);
    const origin = new ThreeVector3();
    return (self, bounds, fov, aspectRatio) => {
        const fovRad = degreeToRadian(fov) * Math.min(aspectRatio, 1);
        const { center, radius } = bounds;
        const distance = (radius * RADIUS_SCALE) / Math.tan(fovRad * 0.5);
        origin.copy(Z).multiplyScalar(distance).add(center);
        self.distance = distance;
        self.origin.x = origin.x;
        self.origin.y = origin.y;
        self.origin.z = origin.z;
        self.target.x = center.x;
        self.target.y = center.y;
        self.target.z = center.z;
    };
})();
export function createFromBounds(bounds, fov, aspectRatio = 1) {
    const ref = create();
    setFromBounds(ref, bounds, fov, aspectRatio);
    return ref;
}
